// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playerArtwork {\n    /* background: #ED3283; */\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16), 0px 8px 16px rgba(0, 0, 0, 0.08), 0px 24px 40px rgba(0, 0, 0, 0.08);\n    border-radius: 16px;\n}\n\n.progress-duration {\n    font-family: -apple-system, BlinkMacSystemFont, sans-serif;\n    position: relative;\n    top: -18px;\n    font-size: 12px;\n    line-height: 12px;\n    letter-spacing: -0.36px;\n    color: #ED3283;\n    text-align: right;\n}", ""]);
// Exports
module.exports = exports;
